import ProductCardV2, { ProductCardV2Props } from 'components/ProductCardV2';
import ShapeCard, { ShapeCardProps } from 'components/ShapeCard';
import React from 'react';

import ActionCard, { ActionCardProps } from './ActionCard';
import AdvertisementCard, { AdvertisementCardProps } from './AdvertisementCard';
import InfoCardV2, { InfoCardV2Props } from './InfoCardV2';

export type ComponentNames =
  | 'ProductCardV2'
  | 'ShapeCard'
  | 'InfoCardV2'
  | 'ActionCard'
  | 'AdvertisementCard';

type ComponentPropsMapping = {
  ProductCardV2: ProductCardV2Props;
  ShapeCard: ShapeCardProps;
  InfoCardV2: InfoCardV2Props;
  ActionCard: ActionCardProps;
  AdvertisementCard: AdvertisementCardProps;
  // Add more components here as needed
};

type InferCardProps<T extends keyof ComponentPropsMapping> =
  ComponentPropsMapping[T];

export type CardBuilderProps<T extends keyof ComponentPropsMapping> = {
  componentName: T;
} & InferCardProps<T>;

const components: Record<ComponentNames, React.ComponentType<any>> = {
  ProductCardV2: ProductCardV2,
  ShapeCard: ShapeCard,
  InfoCardV2: InfoCardV2,
  ActionCard: ActionCard,
  AdvertisementCard: AdvertisementCard,
};

const CardBuilder = <T extends ComponentNames>({
  componentName,
  ...cardProps
}: CardBuilderProps<T>) => {
  const component = components[componentName];

  if (component === undefined) return null;

  return React.createElement(component, cardProps);
};

export default CardBuilder;
